import { ConsigBalanceSolicitation } from "@/models/consignado/balanceSolicitation.model";
import { axiosConsignadoInstance } from "../axiosInstance";
import { FilterFields } from "@/components/consignado/ConsignadoSimulationPage";

export type ConsigBalanceSolicitationProps = {
  page: number;
  pageSize: number;
  filterBy: FilterFields
  filterValue: string;
};

export const getConsignadoBalanceSolicitations = async ({
  page,
  pageSize,
  filterBy,
  filterValue,
}: ConsigBalanceSolicitationProps): Promise<{
  data: ConsigBalanceSolicitation[];
  totalPages: number;
}> => {
  try {
    
    const response = await axiosConsignadoInstance.get(`/api-consignado-trabalhador/v1/balance-solicitation/admin`, {
      params: {
        pagina: page,
        tamanhoPagina: pageSize,
        filtrarPor: filterBy,
        valorFiltro: filterValue,
      },
    });

    const data = {
      data: response.data.itens,
      totalPages: response.data.total_paginas
    }
    return data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};

export const cleanConsignadoBalanceSolicitation = async (
  balanceSolicitationIds: string[]
): Promise<ConsigBalanceSolicitation | null> => {
  try {
    const response = await axiosConsignadoInstance.put(
      `/api/balance-solicitation/corban`,
      balanceSolicitationIds
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao limpar consultas:", error);
    throw error;
  }
};

export const updateStatusConsignadoBalanceSolicitation = async (
  id: string,
  status: string
): Promise<ConsigBalanceSolicitation | null> => {
  try {
    const response = await axiosConsignadoInstance.patch(
      `/api-consignado-trabalhador/v1/balance-solicitation/${id}/status`,
      { status }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar status da solicitação de saldo:", error);
    throw error;
  }
};
export const downloadBalanceSolicitationsExcel = async({startDate, endDate}: {startDate: Date | null,  endDate: Date | null}) => {
  if (!startDate || !endDate) {
    throw new Error("Missing required parameters");
  }

  const response = await axiosConsignadoInstance.get('/api-consignado-trabalhador/v1/balance-solicitation/download-report', {
    params: {
      date: startDate.toISOString().split("T")[0],
      // endDate: endDate.toISOString().split("T")[0],
    },
    responseType: "blob",
  })

  return response.data
}

